import React from "react";

import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";
import { CreateExercisePayload } from "./CreationModal.d";

export const createExercise = (
  language: string,
  payload: CreateExercisePayload,
  setLoading: Function,
  onSuccess: Function,
  showAlert?: Function,
  popAlert?: Function
) => {
  setLoading(true);

  ApiService.post("exercises", payload)
    .then((resp) => onSuccess(resp.data))
    .catch((error) => {
      const apiError = (error as any)?.data;

      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.EXERCISES.CREATION_MODAL.ALERTS.ERROR_TITLE"),
        message: apiError?.error?.message || translate(language, "PAGES.EXERCISES.CREATION_MODAL.ERRORS.CREATION"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.EXERCISES.CREATION_MODAL.ALERTS.BUTTON_CLOSE"),
            variant: "danger",
            onClick: () => popAlert?.(),
          },
        ],
        extraContent: apiError ? (
          <pre className="text-start off-white-background p-2 rounded border">{JSON.stringify(apiError, null, 2)}</pre>
        ) : null,
      });
    })
    .finally(() => setLoading(false));
};

export const fetchInstances = (language: string, setLoading: Function, setInstances: Function) => {
  setLoading(true);

  ApiService.get("instances")
    .then((response) => setInstances(response.data.instances))
    .catch((error) => {
      console.error("Error loading instances:", error);
      alert(translate(language, "PAGES.EXERCISES.CREATION_MODAL.ERRORS.LOADING_INSTANCES"));
    })
    .finally(() => setLoading(false));
};
